var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-box",class:{
    'tag-box--easty': _vm.directionIsEasty,
    'tag-box--southy': _vm.directionIsSouthy,
    'tag-box--box-shadow': _vm.boxShadow !== false
  },style:([
    _vm.styles,
    {
      '--tag-bg-color': _vm.backgroundColour,
      '--tag-text-color': _vm.textColour
    }
  ]),attrs:{"id":_vm.$attrs._id}},[_c('div',{staticClass:"tag-box__arrow-col"},[_c('fa',{style:(_vm.arrowStyle),attrs:{"icon":'arrow-up'}})],1),_c('div',{staticClass:"tag-box__content-col"},[_c('div',{staticClass:"tag-box__label",domProps:{"innerHTML":_vm._s(_vm.label[_vm.activeLanguage.code])}}),_c('div',{staticClass:"tab-box__distance"},[_c('fa',{staticClass:"tag-box__car",attrs:{"icon":['fad', _vm.faIcon]}}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.distance[_vm.activeLanguage.code])}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }